import Abbr from './Abbr';
import './abbr.scss';

export default Abbr;



// WEBPACK FOOTER //
// ./~/rp-react-common/Abbr/index.js